import { render, staticRenderFns } from "./GatewayCharges.vue?vue&type=template&id=3b9dc1ca&scoped=true"
import script from "./GatewayCharges.vue?vue&type=script&lang=js"
export * from "./GatewayCharges.vue?vue&type=script&lang=js"
import style0 from "./GatewayCharges.vue?vue&type=style&index=0&id=3b9dc1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dc1ca",
  null
  
)

export default component.exports